import { Client } from "@core/Client"
import { Constants, MessageType } from "@core/Utils/Constants"
import { Language, Messages } from "./Language"
import { ChatBoxResizeIcon, CloseButton } from "./Utils/IconsSVG"

export class ChatBox {
    constructor(private scene: Phaser.Scene) {
        this.dom = this.scene.add.dom(0, 0).createFromHTML(this.html)
        this.dom.setOrigin(0, 0)

        this.dom.addListener('mouseup')
        this.dom.on('mouseup', this.handler, this)
        this.dom.addListener('mousedown')
        this.dom.on('mousedown', this.handler, this)
        this.dom.addListener('touchstart')
        this.dom.on('touchstart', this.handler, this)
        this.dom.addListener('touchend')
        this.dom.on('touchend', this.handler, this)
        this.dom.addListener('click')
        this.dom.on('click', this.handler, this)

        document.getElementById("fname").addEventListener("focus", function () {
            this.prepareForZoomIn = true
        }.bind(this))

        document.getElementById("fname").addEventListener("blur", function () {
            this.prepareForZoomIn = false
        }.bind(this))

        this.chatMessages = []

        this.scene.game.events.addListener(Constants.EVENTS.CHAT_MESSAGE, (message: string, messageType: MessageType) => {
            this.addMessage(message, messageType);
        })

        this.scene.game.events.addListener(Constants.EVENTS.CHATBOX_TOGGLE, () => {
            if (this.closed)
                this.openChatBox()
            else
                this.closeChatBox()
        })

        this.scene.game.events.addListener(Constants.EVENTS.SCENE_GLOBAL_POINTER_DOWN_EVENT, () => {
            // More robust and working on iOS
            (document.getElementById("fname") as HTMLInputElement).blur();
        })

        this.node = document.getElementsByClassName("chatbox-input")[0]
        this.node.addEventListener("keyup", function (e: any) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                this.sendMessage(e.srcElement.value)
                e.srcElement.value = ""
            }
        }.bind(this));

        $(".chatbox-window").resizable({ handles: "se" });
        $(".chatbox-window").on("resize", (event, ui) => {
            let scale = window.devicePixelRatio;
            if (this.portraitMode) {
                ui.size.width = event.clientY * scale;
                ui.size.height = -((event.clientX - window.innerWidth) * scale);

                if (ui.size.height > (window.innerWidth / 2) * scale) {
                    ui.size.height = (window.innerWidth / 2) * scale;
                }
                if (ui.size.width > (window.innerHeight / 2) * scale) {
                    ui.size.width = (window.innerHeight / 2) * scale;
                }

                if (ui.size.height < (window.innerWidth / 5) * scale) {
                    ui.size.height = (window.innerWidth / 5) * scale;
                }
                if (ui.size.width < (window.innerHeight / 5) * scale) {
                    ui.size.width = (window.innerHeight / 5) * scale;
                }
            }
            else {
                ui.size.width = event.clientX * scale;
                ui.size.height = event.clientY * scale;

                if (ui.size.width > (window.innerWidth / 2) * scale) {
                    ui.size.width = (window.innerWidth / 2) * scale;
                }
                if (ui.size.height > (window.innerHeight / 2) * scale) {
                    ui.size.height = (window.innerHeight / 2) * scale;
                }

                if (ui.size.width < (window.innerWidth / 5) * scale) {
                    ui.size.width = (window.innerWidth / 5) * scale;
                }
                if (ui.size.height < (window.innerHeight / 5) * scale) {
                    ui.size.height = (window.innerHeight / 5) * scale;
                }
            }
        });
        $(".chatbox-window .ui-resizable-se").css('background-image', 'url(' + ChatBoxResizeIcon + ')');
        $(".chatbox-window .ui-resizable-se").css('filter', 'invert(1)');

        this.dom.node.parentElement.style.zIndex = "1"
    }

    get DOM(): Phaser.GameObjects.DOMElement {
        return this.dom
    }

    get InputBoxHeight(): number {
        return (document.getElementById("fname").getBoundingClientRect().height);
        // return parseInt(document.getElementById("fname").style.height);
    }

    // Used for hiding the keyboard on mobile devices to avoid portrait mode problems
    DisableInputBox(): void {
        (document.getElementById("fname") as HTMLInputElement).disabled = true;
        // More robust and working on iOS
        (document.getElementById("fname") as HTMLInputElement).blur();
        if (this.scene.game.device.os.iOS && this.scene.scale.width > this.scene.scale.height) {
            setTimeout(() => {
                document.documentElement.style.height = `100%`;
                setTimeout(() => {
                    // this line prevents the content
                    // from hiding behind the address bar
                    window.scrollTo(0, 1);
                }, 500);
            }, 500);
        }
    }

    EnableInputBox(): void {
        (document.getElementById("fname") as HTMLInputElement).disabled = false;
        (document.getElementById("fname") as HTMLInputElement).focus();
    }

    Resize(width: number, height: number): void {
        let widthScale = width / this.dom.displayWidth / window.devicePixelRatio

        if (this.dom) this.dom.setScale(widthScale)
        this.savedScale = widthScale
    }

    SetPosition(x: number, y: number, portraitMode?: boolean): void {
        if (portraitMode) {
            x = 0
            y = -this.scene.scale.width
        }

        this.portraitMode = portraitMode;

        if (this.dom)
            this.dom.setPosition(x, y)
        this.savedPositionX = x
        this.savedPositionY = y
    }

    private generateHTML(): string {
        let inputBox = "<input>"
        return this.html
    }

    private sendMessage(message: string): void {
        if (!message || message.length == 0)
            return

        if (/\S/.test(message))
            Client.logic.SubmitChatMessage(message)
    }

    private addMessage(message: string, messageType: MessageType): void {
        message = "[" + this.generateTimestamp() + "] " + message

        let el = document.createElement("div")
        el.className = "chatbox-users-message"
        switch (messageType) {
            case MessageType.PLAYER:
                el.style.color = Constants.PANEL.CHAT_BOX.COLORS.PLAYER_MESSAGE
                break;
            case MessageType.PLAYER_STATUS:
                el.style.color = Constants.PANEL.CHAT_BOX.COLORS.PLAYER_STATUS_MESSAGE
                break
            case MessageType.SYSTEM:
                el.style.color = Constants.PANEL.CHAT_BOX.COLORS.SYSTEM_MESSAGE
                break
            case MessageType.SYSTEM_IMPORTANT:
                el.style.color = Constants.PANEL.CHAT_BOX.COLORS.SYSTEM_IMPORTANT_MESSAGE
                break
        }
        if (this.chatMessages.length > this.maxMessages)
            this.chatMessages.shift().remove()

        el.appendChild(document.createTextNode(message))
        this.chatMessages.push(el)
        document.getElementsByClassName('chatbox-messages')[0].appendChild(el)
    }

    private generateTimestamp(): string {
        let now = new Date()
        return ("0" + now.getHours()).slice(-2) + ":" + ("0" + now.getMinutes()).slice(-2) + ":" + ("0" + now.getSeconds()).slice(-2)
    }

    public handler(event: any): void {
        if (event.target.className == "chatbox-open-button") {
            this.openChatBox()
            return
        }

        if (event.target.className == "chatbox-close-button" || event.target.className == "chatbox-close-button-img") {
            this.closeChatBox()
            this.closed = true;
            return
        }

        if (event.target.className == "chatbox-input") {
            this.EnableInputBox();
        }

        if (event.type == "mouseup") {
            $(".chatbox-window").resizable().trigger('mouseup');
        }

        event.stopImmediatePropagation()
        event.stopPropagation()
        event.preventDefault()
    }

    public openChatBox(): void {
        if (!this.closed)
            return;

        this.closed = false;
        (document.getElementsByClassName("chatbox-window")[0] as HTMLElement).style.display = "block";
        (document.getElementById("fname") as HTMLInputElement).disabled = false;

        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
            //TODO
        }
        else {
            (document.getElementById("fname") as HTMLInputElement).focus();
        }
    }

    public closeChatBox(): void {
        if (this.closed)
            return;

        this.closed = true;
        this.DisableInputBox();
        (document.getElementsByClassName("chatbox-window")[0] as HTMLElement).style.display = "none";
    }

    public node: Element;
    public closed = true

    // Change visibility in main CSS file and set closed variable appropriately 
    private savedScale = 1
    private savedPositionX = 0
    private savedPositionY = 0
    private maxMessages = 30
    private messageClearerInterval: number
    private chatMessages: Array<HTMLElement>
    private portraitMode: boolean = false;
    private html = `
                    <div class="chatbox-window">
                        <div class="chatbox-close-button">
                            <img class="chatbox-close-button-img" src="${CloseButton}" />
                        </div>
                        <div class="chatbox-messages" id="chatbox-messages-window">

                        </div>
                        <input type="text" id="fname" name="fname" class="chatbox-input" placeholder="${Language.Get(Messages.CLICK_TO_CHAT)}">
                    </div>
                    `
    private dom: Phaser.GameObjects.DOMElement
}